import Vue from 'vue'
import dayjs from 'dayjs'

Vue.mixin({
  methods: {
    isObject(value) {
      return value && typeof value === 'object' && value.constructor === Object
    },
    requiresAuth() {
      return new Promise((resolve) => {
        if (this.userId) {
          resolve(true)
        } else {
          resolve(false)
          this.$router.push('/login')
        }
      })
    },
    formatIDR(val) {
      if(!val) return 'Rp. 0'
      return 'Rp. ' + val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    formatDate(val) {
      if (!val) return ''
      var newDate
      if(val.toDate) {
        newDate = val.toDate()
      } else {
        newDate = val
      }

      return dayjs(newDate).format('DD-MM-YYYY')
    },
    formatDateFlatpickr(val) {
      if (!val) return ''
      var newDate
      if(val.toDate) {
        newDate = val.toDate()
      } else {
        newDate
      }

      return dayjs(newDate).format('YYYY-MM-DD')
    },
    sumObjectInArray(arr, key) {
      var total = 0
      for (var i = 0, _len = arr.length; i < _len; i++) {
        if(arr[i][key]) {
          total += parseInt(arr[i][key])
        }
      }
      return total
    },
    notifyError(msg) {
      this.$vs.notify({
        title: 'Error',
        text: msg,
        color: 'danger',
        icon: 'error',
        fixed: true
      })
    },
    notifySuccess(msg, fixed = false) {
      this.$vs.notify({
        title: 'Success',
        text: msg,
        color: 'success',
        icon: 'check_circle',
        fixed: fixed
      })
    },
    showConfirmDeletion(action) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure want to delete this item?',
        accept: action
      })
    }
  }
})
